import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProgressBarService } from '@services/progress-bar.service';

/**
 * Set on an HttpRequest's context (via `new HttpContext().set(SKIP_LOADING, true)`) to
 * suppress the global progress bar/spinner for that request, e.g. silent background refreshes.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private progressBarService: ProgressBarService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_LOADING)) {
      return next.handle(request);
    }

    this.progressBarService.startLoading();

    return next.handle(request).pipe(
      finalize(() => {
        this.progressBarService.stopLoading();
      })
    );
  }
}

